/**
 * Format a json string to a pretty format .
 */
export default (value: string): string => {
	if (!value) {
		return '';
	}
	try {
		return JSON.stringify(JSON.parse(value), null, 2);
	} catch (e) {
		return value;
	}
};
